import React, { ChangeEvent } from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import { ISelectOption } from "../../../../interfaces/Patient";

interface SelectProps {
  placeholder: string;
  options: ISelectOption[];
  nameOption?: string;
  legendError: string;
  state: {
    field: string;
    isValid: boolean | null;
  };
  changeState: (newState: { field: string; isValid: boolean | null }) => void; // Actualiza aquí también
}
interface InputContainerProps {
  $isValid: boolean;
}

const SelectContainer = styled.div<InputContainerProps>`
  select {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    margin-bottom: 1rem;
    padding-left: 0.7rem;
    background-color: ${colors.blanco};
    color: ${colors.fifth};
    outline: 1px solid ${({ $isValid }) => ($isValid ? "#d9d9d9" : "red")};

    &:active {
      border: 1px solid ${({ $isValid }) => ($isValid ? "#d9d9d9" : "red")};
      outline: none;
    }
  }

  .errorValidation {
    color: red;
    margin-left: 10px;
    margin-top: -0.5rem;
    font-weight: bold;
  }
`;

const Select_Form: React.FC<SelectProps> = ({
  placeholder,
  options,
  legendError,
  state,
  nameOption,
  changeState,
}) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    changeState({ ...state, field: e.target.value });
  };

  const handleValidation = () => {
    if (state.field !== "") {
      changeState({ ...state, isValid: true });
    } else {
      changeState({ ...state, isValid: false });
    }
  };

  const isValid = state.isValid !== false;

  return (
    <SelectContainer $isValid={isValid}>
      <select
        value={state.field}
        onChange={handleChange}
        onBlur={handleValidation}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => {
          if (
            nameOption === "razonesSociales" ||
            nameOption === "areasAfectadas"
          ) {
            return (
              <option key={index} value={`${option.value}-${option.label}`}>
                {option.label}
              </option>
            );
          } else {
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            );
          }
        })}
      </select>
      {state.isValid === false && (
        <p className="errorValidation">{legendError}</p>
      )}
    </SelectContainer>
  );
};

export default Select_Form;
